 <div class="alertbox success" style="padding: 24px">
     <div class="icon">
         <img src="assets/img/icon/success.png" alt="Success">
     </div>
     <h4>{{ "Congrats" | translate }}</h4>
     <p style="white-space: pre-wrap;">
         {{ paymentResult?.extra?.message | replaceLineBreaks }}
     </p>
 </div>
 <div class="pButton">
     <button class="btn btn-primary" (click)="backToMerchant()">{{ "Back to Merchant" | translate }}</button>
 </div>